export default __webpack_public_path__ + "static/media/filterBlue.bdf85442.svg";